import { useTranslation } from 'react-i18next';

import { EMPTY_VALUE_PLACEHOLDER } from '../constants';
import { formatShortDate, formatShortDateRange } from '../lib/date-utils';

export function useDateRangeDisplay(from?: Date | null, to?: Date | null): string {
  const { t } = useTranslation('common');

  if (from && to) return formatShortDateRange(from, to);
  if (from) return t('dates.from', { date: formatShortDate(from) });
  if (to) return t('dates.to', { date: formatShortDate(to) });
  return EMPTY_VALUE_PLACEHOLDER;
}
